import * as moment from 'moment';
import 'moment/locale/es';
import { Tools } from '../utils/tools';
import { TYPE_FORM } from '../utils/constants';

export const Global = {
    convertDate(value) {
        let _val = moment(value, 'YYYY-MM-DD');
        return _val.format('YYYY-MM-DD');
    },

    rangeDate(start, end) {
        return moment.range(moment(start, 'YYYY-MM-DD'), moment(end, 'YYYY-MM-DD'));
    },

    checkGreaterDates(firstdate, seconddate) {
        let first = moment(firstdate, 'YYYY-MM-DD');
        let second = moment(seconddate, 'YYYY-MM-DD');

        return (second > first);
    },

    calculateAge: function (value) {
        let birthday = moment(value, 'YYYY-MM-DD');
        let years = moment().diff(birthday, 'years', false);
        return years;
    },

    formValidation: function (form, fields, pro) {
        let isvalid = false;
        let hfalses = [];

        for (let key in fields) {
            if (fields[key].is_require) {
                if (pro[key] === '') { hfalses.push(false); }
            }
        }
        if (hfalses.length > 0) { isvalid = false; }
        else { isvalid = true; }

        return isvalid;
    },
    formValidationList: function (form, _selectEntity) {
        let isValidateForm = [];
        for (let key in form) {
            if (form[key].isRequired) {
                let a = document.getElementById(key);
                if (_selectEntity[key] === form[key].valueValidate) {
                    a.classList.add("require");
                    let _html_mesg = a.parentNode.querySelector(".invalid-feedback");
                    _html_mesg.textContent = form[key].require_msg;
                    isValidateForm.push(key);
                } else {
                    a.classList.remove("require");
                    let _html_mesg = a.parentNode.querySelector(".invalid-feedback");
                    _html_mesg.textContent = "";
                }
            }
        }
        return isValidateForm;
    },

    validateFormAcademicInformation: function (type, _root) {

        let isValidateForm = [];
        if (type === TYPE_FORM.INF_ACADEMIC_PREGRADO) {
            if ((_root.state.datasend[type].idInstitucionEducativa === '' || _root.state.datasend[type].idGradoEstudio === 15)) {
                isValidateForm.push(`idInstitucionEducativa${type}`);
                this.addMessageError(`idInstitucionEducativa${type}`, 'Institución Educativa es obligatorio');
            } else {
                this.removeMessageError(`idInstitucionEducativa${type}`);
            }
            if (_root.state.datasend[type].profesion === '') {
                isValidateForm.push(`profesion${type}`);
                Global.addMessageError(`profesion${type}`, 'Profesión es obligatorio');
            } else {
                this.removeMessageError(`profesion${type}`);
            }
        }
        if (type === TYPE_FORM.INF_ACADEMIC_PREGRADO || type === TYPE_FORM.INF_ACADEMIC_POSTGRADO) {
            if (_root.state.datasend[type].idGradoEstudio === '' || _root.state.datasend[type].idGradoEstudio === 15) {
                isValidateForm.push(`idGradoEstudio${type}`);
                Global.addMessageError(`idGradoEstudio${type}`, 'Grado es obligatorio');
            } else {
                this.removeMessageError(`idGradoEstudio${type}`);
            }
        }
        if (type === TYPE_FORM.INF_ACADEMIC_POSTGRADO || type === TYPE_FORM.INF_ACADEMIC_OTHERS) {
            if (_root.state.datasend[type].especialidad === '') {
                isValidateForm.push(`especialidad${type}`);
                Global.addMessageError(`especialidad${type}`, 'Especialidad es obligatorio');
            } else {
                this.removeMessageError(`especialidad${type}`);
            }
        }
        if (_root.state.datasend[type].fechaDesde === '') {
            isValidateForm.push(`fechaDesde${type}`);
            Global.addMessageError(`fechaDesde${type}`, 'Fecha Desde - Hasta es obligatorio');
        } else {
            this.removeMessageError(`fechaDesde${type}`);
        }
        if (_root.state.datasend[type].fechaHasta === '') {
            isValidateForm.push(`fechaHasta${type}`);
            Global.addMessageError(`fechaHasta${type}`, 'Fecha Desde - Hasta es obligatorio');
        } else {
            this.removeMessageError(`fechaHasta${type}`);
        }

        console.log('val fech', _root.state.datasend[type].fechaDesde, _root.state.datasend[type].fechaHasta, _root.state.datasend[type].fechaDesde.length, _root.state.datasend[type].fechaHasta.length);
        if (_root.state.datasend[type].fechaHasta !== '' && _root.state.datasend[type].fechaDesde !== '') {
            if (_root.state.datasend[type].fechaDesde.length !== 7 || _root.state.datasend[type].fechaHasta.length !== 7) {
                isValidateForm.push(`fechaHasta${type}`);
                Global.addMessageError(`fechaDesde${type}`, 'Formato de Fecha no válida MES-AÑO.');
                Global.addMessageError(`fechaHasta${type}`, 'Formato de Fecha no válida MES-AÑO.');
            } else {
                var [mesInicio, añoInicio] = _root.state.datasend[type].fechaDesde.split('-').map(Number);
                var [mesFin, añoFin] = _root.state.datasend[type].fechaHasta.split('-').map(Number);
                if (añoFin < añoInicio || (añoFin === añoInicio && mesFin < mesInicio)) {
                    isValidateForm.push(`fechaHasta${type}`);
                    Global.addMessageError(`fechaDesde${type}`, 'La fecha HASTA debe ser mayor que la Fecha DESDE');
                    Global.addMessageError(`fechaHasta${type}`, 'La fecha HASTA debe ser mayor que la Fecha DESDE');
                } else {
                    this.removeMessageError(`fechaDesde${type}`);
                    this.removeMessageError(`fechaHasta${type}`);
                }
            }
        }
        return isValidateForm;
    },
    addMessageError: (id, message) => {
        let a = document.getElementById(id);
        a.classList.add("require");
        let _html_mesg = a.parentNode.querySelector(".invalid-feedback");
        _html_mesg.textContent = message;
    },
    removeMessageError: (id) => {
        let a = document.getElementById(id);
        a.classList.remove("require");
        let _html_mesg = a.parentNode.querySelector(".invalid-feedback");
        _html_mesg.textContent = "";
    },
    checkFormData: function (target, state, form_view, pro) {
        let _root = this;
        let _target = target;
        let _valid_msg = _target.parentNode.querySelector('.invalid-feedback');

        if (state.fields[_target.name] !== undefined) {
            state.fields[_target.name].value = (_target.value != '') ? pro[_target.name] : '';
        }

        if (state.fields[_target.name].is_require) {
            if (state.fields[_target.name].value != '') {
                state.fields[_target.name].hasdata = true;
                _target.classList.remove('require');
                _root.addMsgError(_valid_msg, '');

                switch (form_view) {
                    case 'general_data':
                        if (_target.name == 'fechaNacimiento') {
                            state.fields.edad.value = _root.calculateAge(pro[_target.name]);
                        }
                        if (_target.name == 'email') {
                            if (!Tools.validateEmail(pro[_target.name])) {
                                state.fields[_target.name].hasdata = false;
                                state.fields[_target.name].value = '';
                                _target.classList.add('require');
                                _root.addMsgError(_valid_msg, state.fields[_target.name].validate_msg);
                            }
                            else {
                                state.fields[_target.name].hasdata = true;
                                _target.classList.remove('require');
                                _root.addMsgError(_valid_msg, '');
                            }
                        }
                        break;
                    case 'working_information':
                        if (_target.name == 'laboralEmail') {
                            if (!Tools.validateEmail(pro[_target.name])) {
                                state.fields[_target.name].hasdata = false;
                                state.fields[_target.name].value = '';
                                _target.classList.add('require');
                                _root.addMsgError(_valid_msg, state.fields[_target.name].validate_msg);
                            }
                            else {
                                state.fields[_target.name].hasdata = true;
                                _target.classList.remove('require');
                                _root.addMsgError(_valid_msg, '');
                            }
                        }
                        break;
                }
            }
            else {
                state.fields[_target.name].hasdata = false;
                _target.classList.add('require');
                _root.addMsgError(_valid_msg, state.fields[_target.name].require_msg);

                switch (form_view) {
                    case 'general_data':
                        if (_target.name == 'fechaNacimiento') { state.fields.edad.value = ''; }
                        break;
                }
            }
        }

        return state;
    },

    addMsgError: function (el, msg) {
        if (el) { el.textContent = msg; }
    },

    montoByGradoAcademico: function (ga) {
        let amount = 0.00;
        let costos = {
            MAES: {
                amount: 150.00
            },
            PDE: {
                amount: 150.00
            },
            CEX: {
                amount: 150.00
            },
            CDE: {
                amount: 100.00
            },
            LAB: {
                amount: 150.00
            }
        };

        if (costos[ga] !== undefined) {
            amount = costos[ga].amount;
        }

        return amount;
    },

    validateDateStartEnd: function (value) {
        let resp = false;
        let darr = (value).split('-');
        if (darr.length > 1) {
            let _month = parseInt(darr[0]);
            if (_month > 0 && _month <= 12) {
                if (darr[1].length == 4) {
                    resp = true;
                }
            }
        }

        return resp;
    },

    convertDateStartEnd: function (value) {
        let resp = '';
        let darr = (value).split('-');

        if (darr.length == 3) {
            resp = `${darr[1]}-${darr[0]}`;
        }

        return resp;
    },

    validateOnlyLetter: function (value) {
        var _value = value.split(" ").join('');
        let response = false;
        // let regex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
        let regex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ]+$/i;
        let validate = regex.test(_value);
        if (validate && _value.length > 2) {
            response = true;
        }

        return response;
    },

    documentType: function (value) {
        let docType = 'DNI';

        switch (value) {
            case '1':
                docType = 'DNI';
                break;
            case '2':
                docType = 'CE';
                break;
            case '4':
                docType = 'PASAPORTE';
                break;
        }

        return docType;
    },

    createUUID: function () {
        return (new Date().getTime()).toString(36) + new Date().getUTCMilliseconds();
    },

    isEmpty: function (val) {
        return (val === undefined || val == null || val.length <= 0) ? true : false;
    },

    onKeyPressInputValidate: function (event, param) {
        let _root = this;
        let key = event.key;
        let _value = event.target.value;
        let regex = null;

        switch (param) {
            case 'only_letter':
                //regex = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
                regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]*$/
                if (!regex.test(key)) {
                    event.preventDefault();
                } else {
                    //console.warn("valido...");
                }
                break;
            case 'only_number_positive':
                const key = event.key;
                const regex = /^[0-9]\d*$/;
                // Allow backspace, delete, tab, escape, and enter
                if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].indexOf(key) !== -1 ||
                    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Command+A, Command+C, Command+V, Command+X
                    (event.ctrlKey === true || event.metaKey === true) && (key === 'a' || key === 'c' || key === 'v' || key === 'x') ||
                    // Allow: home, end, left, right, down, up
                    (key >= 35 && key <= 40)) {
                    return;
                }
                // Ensure that it is a number and stop the keypress
                if (!regex.test(key)) {
                    event.preventDefault();
                }
                break;
            case 'only_number_and_letter':
                regex = /^[a-zA-Z0-9]*$/g;
                if (!regex.test(key) && event.key !== 'Backspace') {
                    event.preventDefault();
                } else {
                    //console.warn("valido...");
                }
                break;
            default:

                break;
        }
    },

    dataIsComplete: function (data, view) {
        let _vistas = JSON.parse(data);
        let dataIsComplete = _vistas.includes(view);

        return dataIsComplete;
    },

    addViewComplete: function (data, view) {
        let _vistas = [];

        if (data != '') {
            _vistas = JSON.parse(data);
            _vistas.push(view);
            _vistas = [...new Set(_vistas)];
        }
        else {
            _vistas.push(view);
        }

        return _vistas;
    },

    isEmpty: function (val) {
        return (val === undefined || val === null || val.length <= 0 || val == '') ? true : false;
    }
}